import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { createApiMutationHook } from '../../common/queryClient/createApiMutationHook';
import { getMutationFn } from '../../common/queryClient/getMutationFn';
import { SystemClassifierDto, SystemClassifierValidFormData } from '../schema';
import { SystemClassifierUrl } from './SystemClassifierUrl';

const patchSystemClassifier = (
  id: number,
  systemClassifier: Partial<SystemClassifierValidFormData>
) =>
  apiClient
    .put<SystemClassifierDto>(
      expand(SystemClassifierUrl.SYSTEM_CLASSIFIER, { id }),
      systemClassifier
    )
    .then((response) => response.data);

export const useMutateSystemClassifier = createApiMutationHook(
  ['system-classifier'],
  getMutationFn(undefined, patchSystemClassifier, undefined)
);
